import React, { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import brokenHeart from "../imagesHome/brokenHeart.png";
import startupRocket from "../imagesHome/startuprocket.png";
import cuteConti from "../imagesHome/cuteConti.png";
import coinImg from "../header/images/coin.png";
import "./NoLivesPopup.css";

const NoLivesPopup = ({ onClose, onBuyLife, onContinue, availableCoins = 0, lifePrice = 50 }) => {
  const [panelStep, setPanelStep] = useState("initial");
  const [isBuying, setIsBuying] = useState(false);
  const [hasPurchasedLife, setHasPurchasedLife] = useState(false);
  const [selectedLifeIndexes, setSelectedLifeIndexes] = useState([]);
  const [purchasedLifeIndexes, setPurchasedLifeIndexes] = useState([]);
  const [purchaseError, setPurchaseError] = useState("");
  const [displayCoins, setDisplayCoins] = useState(Number(availableCoins) || 0);

  useEffect(() => {
    setDisplayCoins(Number(availableCoins) || 0);
  }, [availableCoins]);

  const selectedLivesCount = useMemo(() => selectedLifeIndexes.length, [selectedLifeIndexes]);
  const totalPrice = useMemo(() => selectedLivesCount * lifePrice, [selectedLivesCount, lifePrice]);
  const hasSelectedLives = useMemo(() => selectedLivesCount > 0, [selectedLivesCount]);
  const canAffordLife = useMemo(() => displayCoins >= totalPrice, [displayCoins, totalPrice]);
  const formattedDisplayCoins = useMemo(() => Number(displayCoins || 0).toLocaleString("ro-RO"), [displayCoins]);

  const handleOpenPurchasePanel = () => {
    setPanelStep("purchase");
    setPurchaseError("");
    setSelectedLifeIndexes([]);
    setPurchasedLifeIndexes([]);
    setHasPurchasedLife(false);
  };

  const handleBuyLife = async () => {
    if (hasPurchasedLife || isBuying) return;

    if (!hasSelectedLives) {
      setPurchaseError("Selectează cel puțin o viață.");
      return;
    }

    if (!canAffordLife) {
      setPurchaseError("Nu ai suficiente monede pentru această achiziție.");
      return;
    }

    setIsBuying(true);
    setPurchaseError("");

    try {
      const buyResult = (await onBuyLife?.(selectedLivesCount)) ?? true;

      if (buyResult === false || buyResult === null) {
        setPurchaseError("Achiziția nu a putut fi finalizată. Încearcă din nou.");
        return;
      }

      if (typeof buyResult === "number" && Number.isFinite(buyResult)) {
        setDisplayCoins(buyResult);
      } else {
        setDisplayCoins((prev) => prev - totalPrice);
      }

      setPurchasedLifeIndexes([...selectedLifeIndexes]);
      setHasPurchasedLife(true);
    } catch (error) {
      setPurchaseError("A apărut o eroare la cumpărarea vieții.");
    } finally {
      setIsBuying(false);
    }
  };

  return (
    <div className="nolives-overlay">
      <div className="nolives-popup">
        {panelStep === "initial" ? (
          <>
            <h2>Ai ramas fara vieti</h2>
            <img src={brokenHeart} alt="Inima franta" className="nolives-broken-heart" />
          
           
            <p>
              Poti reincerca lectia oricand esti pregatit!
            </p>

            <img src={startupRocket} alt="Racheta startup" className="nolives-startup-rocket" />

            <div className="nolives-conti-talk">
              <p className="nolives-conti-message">Sau poti continua lectia cumparand vieti!</p>
              <img src={cuteConti} alt="Conti cute" className="nolives-cute-conti" />
            </div>

            <div className="nolives-actions">
             
              <button className="nolives-btn nolives-btn--answer-like" onClick={handleOpenPurchasePanel}>
                Cumpara vieti
              </button>
               <button className="nolives-btn nolives-btn--back-like" onClick={onClose}>
                Inapoi la lectii
              </button>
            </div>
          </>
        ) : (
          <div className="nolives-purchase-panel">
            <h3>
              {hasPurchasedLife
                ? `Ai cumparat ${purchasedLifeIndexes.length} ${purchasedLifeIndexes.length === 1 ? "viata" : "vieti"}!`
                : "Selecteaza numarul de vieti!"}
            </h3>

            <div className="nolives-hearts-row" aria-label="Vieți disponibile pentru lecția curentă">
              {[0, 1, 2].map((index) => (
                <button
                  key={index}
                  type="button"
                  className={`nolives-heart ${(hasPurchasedLife ? purchasedLifeIndexes.includes(index) : selectedLifeIndexes.includes(index)) ? "is-filled" : "is-empty"} ${!hasPurchasedLife ? "is-selectable" : ""}`}
               onClick={() => {
  if (hasPurchasedLife) return;

  setSelectedLifeIndexes(
    Array.from(
      { length: index + 1 },
      (_, i) => i
    )
  );

  setPurchaseError("");
}}
                  aria-label={`Selectează sau deselectează viața ${index + 1}`}
                  aria-pressed={!hasPurchasedLife && selectedLifeIndexes.includes(index)}
                  disabled={hasPurchasedLife}
                >
                  <FontAwesomeIcon icon={(hasPurchasedLife ? purchasedLifeIndexes.includes(index) : selectedLifeIndexes.includes(index)) ? faHeartSolid : faHeartRegular} />
                </button>
              ))}
            </div>

            <div className="nolives-conti-talk nolives-conti-talk--purchase">
              <p className="nolives-conti-message">
                {hasPurchasedLife
                  ? "Acum poti finaliza lectia."
                  : hasSelectedLives && !canAffordLife
                  ? "Nu ai suficiente monede pentru a cumpara vieti"
                  : hasSelectedLives
                  ? `${selectedLivesCount} ${selectedLivesCount === 1 ? "viata costa" : "vieti costa"} ${totalPrice} monede.`
                  : "Vietile cumparate pot fi utilizate doar in cadrul lectiei curente."}
              </p>
              <img src={cuteConti} alt="Conti cute" className="nolives-cute-conti" />
            </div>

            {!hasPurchasedLife && (
              <div className="nolives-balance-box">
                <span>Sold disponibil:</span>
                <strong className="nolives-balance-value">
                  <img src={coinImg} alt="Monede" className="nolives-balance-coin" />
                  {formattedDisplayCoins}
                </strong>
              </div>
            )}

            {purchaseError && <p className="nolives-error">{purchaseError}</p>}

            {!hasPurchasedLife ? (
              <button
                className="nolives-btn nolives-btn--buy-red-like"
                onClick={handleBuyLife}
                disabled={isBuying || !canAffordLife || !hasSelectedLives}
              >
                {isBuying
                  ? "Se procesează..."
                  : hasSelectedLives
                    ? `Cumpara ${selectedLivesCount} ${selectedLivesCount === 1 ? "viata" : "vieti"}`
                    : "Cumpara"}
              </button>
            ) : (
              <button className="nolives-btn nolives-btn--answer-like" onClick={onContinue || onClose}>
                Continua
              </button>
            )}

            {!hasPurchasedLife && (
              <button
                className="nolives-btn nolives-btn--back-like"
                onClick={() => {
                  setPanelStep("initial");
                  setPurchaseError("");
                }}
              >
                 
                Inapoi
             
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default NoLivesPopup;
